import { RouterModule, Routes } from '@angular/router';
import { AuthGuard, LoginGuard } from './_guards';
import { LoginComponent } from './views/login/login.component';
import { AppComponent } from './app.component';

const AppRoutes: Routes = [
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  {
    path: '',
    children: [
      { path: '', loadChildren: () => import('./nyvus3.module').then(m => m.Nyvus3Module), canLoad: [AuthGuard] },
      { path: '**', redirectTo: '' },
    ]
  },
];

export const AppRoutingModule = RouterModule.forRoot(AppRoutes, { useHash: true });